import React, { useContext, Fragment, useEffect } from "react";
import { TipoDocsContext } from "../TipoDocsContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarTipoDocs = () => {
  const { values, setValues, resetScreen } = useContext(TipoDocsContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={TipoDocsContext}>
        <div className="col-12 col-md-4">
          <label>Descrição</label>
          <input
            className="form-control"
            type="text"
            name="tipoDocsNome"
            value={values.searchData.tipoDocsNome}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={TipoDocsContext} />
    </Fragment>
  );
};

export default PesquisarTipoDocs;
